import React, { useState } from 'react';
import { 
  FiSearch, 
  FiFilter, 
  FiEye, 
  FiActivity, 
  FiCheckCircle, 
  FiXCircle, 
  FiMapPin, 
  FiPhone,
  FiFileText,
  FiUser
} from 'react-icons/fi';

const GramPanchayatManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDistrict, setFilterDistrict] = useState('');
  const [filterTaluka, setFilterTaluka] = useState('');
  const [showProfile, setShowProfile] = useState(null);

  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    active: '#10b981',
    inactive: '#ef4444',
    bg: '#f8fafc',
    text: '#333333'
  };

  // Sample Data
  const panchayats = [
    {
      id: 1,
      name: 'ग्रामपंचायत इनाम धामणी',
      sarpanch: 'श्री. विश्वास पाटील',
      gramsevak: 'श्रीमती. सरिता जोशी',
      contact: '९८७६५४३२१०',
      status: 'सक्रिय',
      performance: 95,
      loginStatus: 'On',
      district: 'सांगली',
      taluka: 'मिरज',
      funds: '₹२५,००,०००',
      appsSubmitted: 156,
      lastLogin: '२०/०२/२०२६ १०:३० सकाळी'
    },
    {
      id: 2,
      name: 'ग्रामपंचायत बेडग',
      sarpanch: 'श्री. रमेश देसाई',
      gramsevak: 'श्री. अमोल शिंदे',
      contact: '९८७६५४३२११',
      status: 'निष्क्रिय',
      performance: 45,
      loginStatus: 'Off',
      district: 'सांगली',
      taluka: 'मिरज',
      funds: '₹८,००,०००',
      appsSubmitted: 45,
      lastLogin: '१८/०२/२०२६ ०४:०० दुपारी'
    },
    {
      id: 3,
      name: 'ग्रामपंचायत आरग',
      sarpanch: 'श्रीमती. अलका पवार',
      gramsevak: 'श्री. विजय काळे',
      contact: '९८७६५४३२१२',
      status: 'सक्रिय',
      performance: 92,
      loginStatus: 'On',
      district: 'सांगली',
      taluka: 'मिरज',
      funds: '₹१८,००,०००',
      appsSubmitted: 210,
      lastLogin: '२०/०२/२०२६ ११:१५ सकाळी'
    }
  ];

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-6 flex flex-col md:flex-row justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>ग्रामपंचायत व्यवस्थापन</h1>
          <p className="text-gray-600 text-sm">जिल्हा आणि तालुका निहाय ग्रामपंचायतींचे निरीक्षण करा.</p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col md:flex-row gap-4 items-end">
        <div className="flex-1 w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">जिल्हा निवडा</label>
          <select 
            className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2"
            style={{ borderColor: '#e5e7eb', '--tw-ring-color': colors.secondary }}
            onChange={(e) => setFilterDistrict(e.target.value)}
          >
            <option value="">सर्व जिल्हे</option>
            <option value="sangli">सांगली</option>
            <option value="satara">सातारा</option>
            <option value="kolhapur">कोल्हापूर</option>
          </select>
        </div>
        <div className="flex-1 w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">तालुका निवडा</label>
          <select 
            className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2"
            style={{ borderColor: '#e5e7eb', '--tw-ring-color': colors.secondary }}
            onChange={(e) => setFilterTaluka(e.target.value)}
          >
            <option value="">सर्व तालुके</option>
            <option value="miraj">मिरज</option>
            <option value="tasgaon">तासगाव</option>
            <option value="palus">पलूस</option>
          </select>
        </div>
        <div className="flex-[2] w-full relative">
          <label className="block text-sm font-medium text-gray-700 mb-1">शोध (ग्रामपंचायत नाव)</label>
          <div className="relative">
            <FiSearch className="absolute left-3 top-3 text-gray-400" />
            <input 
              type="text" 
              placeholder="ग्रामपंचायत नाव शोधा..." 
              className="w-full pl-10 p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2"
              style={{ borderColor: '#e5e7eb', '--tw-ring-color': colors.secondary }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <button 
          className="px-6 py-2.5 text-white font-medium rounded-lg shadow-sm hover:opacity-90 transition-opacity"
          style={{ backgroundColor: colors.primary }}
        >
          <FiFilter className="inline mr-2" /> फिल्टर करा
        </button>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 text-gray-700 text-sm">
                <th className="p-4 font-semibold border-b">अ.क्र.</th>
                <th className="p-4 font-semibold border-b">ग्रामपंचायत नाव</th>
                <th className="p-4 font-semibold border-b">सरपंच / ग्रामसेवक</th>
                <th className="p-4 font-semibold border-b">संपर्क क्रमांक</th>
                <th className="p-4 font-semibold border-b text-center">कार्यप्रदर्शन</th>
                <th className="p-4 font-semibold border-b text-center">स्थिती</th>
                <th className="p-4 font-semibold border-b text-center">कृती</th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              {panchayats.map((gp, index) => (
                <tr key={gp.id} className="hover:bg-gray-50 transition-colors">
                  <td className="p-4 text-gray-600">{index + 1}</td>
                  <td className="p-4 font-medium" style={{ color: colors.text }}>
                    {gp.name}
                    <div className="text-xs text-gray-500 mt-0.5 max-w-[150px] truncate">
                      <FiMapPin className="inline mr-1" size={10} />{gp.taluka}, {gp.district}
                    </div>
                  </td>
                  <td className="p-4 text-gray-600">
                    <div className="font-medium">{gp.sarpanch}</div>
                    <div className="text-xs text-gray-500">{gp.gramsevak}</div>
                  </td>
                  <td className="p-4 text-gray-600 font-mono">{gp.contact}</td>
                  <td className="p-4 text-center">
                    <div className="inline-block px-3 py-1 rounded-full text-xs font-bold"
                      style={{ 
                        backgroundColor: gp.performance > 80 ? '#dcfce7' : gp.performance > 50 ? '#fef9c3' : '#fee2e2',
                        color: gp.performance > 80 ? '#166534' : gp.performance > 50 ? '#854d0e' : '#991b1b'
                      }}>
                      {gp.performance}%
                    </div>
                  </td>
                  <td className="p-4 text-center">
                    {gp.status === 'सक्रिय' ? (
                      <span className="flex items-center justify-center text-green-600 text-xs font-medium">
                        <FiCheckCircle className="mr-1" /> सक्रिय
                      </span>
                    ) : (
                      <span className="flex items-center justify-center text-red-600 text-xs font-medium">
                        <FiXCircle className="mr-1" /> निष्क्रिय
                      </span>
                    )}
                  </td>
                  <td className="p-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                       <button 
                        onClick={() => setShowProfile(gp)}
                        className="p-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 transition-colors"
                        title="प्रोफाइल पहा"
                      >
                        <FiEye size={16} />
                      </button>
                      <button 
                        className="p-2 rounded-lg bg-teal-50 hover:bg-teal-100 text-teal-700 transition-colors"
                        title="कामगिरी अहवाल"
                      >
                        <FiActivity size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Profile Modal */}
      {showProfile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden animate-fade-in-up">
            <div className="p-6 border-b flex justify-between items-center" style={{ backgroundColor: colors.primary }}>
              <h2 className="text-xl font-bold text-white flex items-center">
                <FiUser className="mr-2" /> {showProfile.name} - तपशील
              </h2>
              <button onClick={() => setShowProfile(null)} className="text-white hover:bg-white/20 p-1.5 rounded-full transition-colors">
                <FiXCircle size={24} />
              </button>
            </div>
            
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <h3 className="font-bold text-gray-800 border-b pb-2 mb-3">मूलभूत माहिती</h3>
                <div className="flex justify-between">
                  <span className="text-gray-500">जिल्हा:</span>
                  <span className="font-medium text-gray-800">{showProfile.district}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">तालुका:</span>
                  <span className="font-medium text-gray-800">{showProfile.taluka}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">सरपंच:</span>
                  <span className="font-medium text-gray-800">{showProfile.sarpanch}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">ग्रामसेवक:</span>
                  <span className="font-medium text-gray-800">{showProfile.gramsevak}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">संपर्क:</span>
                  <span className="font-medium text-gray-800">{showProfile.contact}</span>
                </div>
              </div>

              <div className="space-y-4">
                <h3 className="font-bold text-gray-800 border-b pb-2 mb-3">कामगिरी व आकडेवारी</h3>
                <div className="flex justify-between items-center bg-green-50 p-2 rounded">
                  <span className="text-green-800">एकूण निधी:</span>
                  <span className="font-bold text-green-900">{showProfile.funds}</span>
                </div>
                <div className="flex justify-between items-center bg-blue-50 p-2 rounded">
                  <span className="text-blue-800">अर्ज संख्या:</span>
                  <span className="font-bold text-blue-900">{showProfile.appsSubmitted}</span>
                </div>
                <div className="flex justify-between items-center bg-purple-50 p-2 rounded">
                  <span className="text-purple-800">कामगिरी गुण:</span>
                  <span className="font-bold text-purple-900">{showProfile.performance}/100</span>
                </div>
                
                <h3 className="font-bold text-gray-800 border-b pb-2 mt-4 mb-2">सिस्टम माहिती</h3>
                 <div className="flex justify-between">
                  <span className="text-gray-500">लॉगिन स्थिती:</span>
                  <span className={`font-medium ${showProfile.loginStatus === 'On' ? 'text-green-600' : 'text-red-500'}`}>
                    {showProfile.loginStatus === 'On' ? 'Online' : 'Offline'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">शेवटचे लॉगिन:</span>
                  <span className="font-medium text-gray-800 text-sm">{showProfile.lastLogin}</span>
                </div>
              </div>
            </div>

            <div className="p-4 bg-gray-50 flex justify-end gap-3 border-t">
              <button 
                className="px-4 py-2 text-red-600 bg-white border border-red-200 hover:bg-red-50 rounded-lg transition-colors font-medium"
              >
                अक्षम करा (Disable)
              </button>
              <button 
                className="px-4 py-2 text-white rounded-lg transition-colors font-medium shadow-sm"
                style={{ backgroundColor: colors.primary }}
              >
                संपूर्ण अहवाल पाहा
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GramPanchayatManagement;
